import { useMemo } from 'react';
import { useGetProviderlessStartConversation } from './useGetProviderlessStartConversation';
import { LineOfBusinesses } from '../constants/LineOfBusiness';
import { useSdkStatus } from './useSdkStatus';
export const useConversationSDK = (conversationParams) => {
    const { lineOfBusiness, redirectUri, language, clientId } = conversationParams;
    const getLanguageOrDefaultBasedOnLineOfBusiness = useMemo(() => {
        if (lineOfBusiness === LineOfBusinesses.S4P ||
            lineOfBusiness === LineOfBusinesses.S4P_STAGING) {
            return 'en-US';
        }
        return language;
    }, [language, lineOfBusiness]);
    const conversation = useMemo(() => ({
        conversationParams: {
            lineOfBusiness,
            redirectUri,
            language: getLanguageOrDefaultBasedOnLineOfBusiness,
            clientId,
        },
    }), [
        clientId,
        getLanguageOrDefaultBasedOnLineOfBusiness,
        lineOfBusiness,
        redirectUri,
    ]);
    const sdkStatus = useSdkStatus(lineOfBusiness, clientId);
    const { startConversation } = useGetProviderlessStartConversation(lineOfBusiness, clientId, language, redirectUri);
    return { startConversation, conversation, sdkStatus };
};
